import { useClientContext } from "../../../hooks/ClientContext"
import { useGetMasterAccountDashboardLoginSummaryQuery } from "../../../services/clientauth/clientAuthApiEndpoints";

export const useGetDashboardLoginsSummaryDetails = () => {
    const { id: masterAccountId } = useClientContext();
    const { data, error, isLoading } = useGetMasterAccountDashboardLoginSummaryQuery({masterAccountId});

    return {
        data, error, isLoading
    }
}